<!-- 代理等级变更日志 -->
<template>
    <div>
        <c-dialog ref="importLogDialog" :title="dialogTitle" width="1200" height="800" enable-flex :button="false">
            <m-search ref="search" @search="search">
                <c-form ref="form" inline>
                    <c-form-item type="select" label="执行状态" name="execute_state" :options="executeStateOptions"></c-form-item>
                    <c-form-item type="select" label="导入结果" name="state" :options="stateOptions"></c-form-item>
                    <c-form-item type="input" label="操作用户" name="create_user_realname"></c-form-item>
                    <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date"></c-form-item>
                </c-form>
            </m-search>
            <c-table ref="table" height="770">
                <c-table-column label="任务ID" width="50" name="id">
                </c-table-column>
                <c-table-column label="执行状态" width="80">
                    <template v-slot="{data}">
                        <span v-if="data.execute_state == 0" style="color:darkgray">待执行</span>
                        <span v-if="data.execute_state == 1" style="color:brown">执行中</span>
                        <span v-if="data.execute_state == 2" style="color:green">执行完成</span>
                    </template>
                </c-table-column>
                <c-table-column label="导入结果" width="80">
                    <template v-slot="{data}">
                        <span v-if="data.execute_state == 2 && data.state == 0" style="color:red">导入失败</span>
                        <span v-else-if="data.execute_state == 2 && data.state == 1" style="color:brown">部分成功</span>
                        <span v-else-if="data.execute_state == 2 && data.state == 2" style="color:green">导入成功</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>
                <c-table-column
                        label="文件下载"
                        name="upload_file_url"
                        width="100"
                >
                    <template v-slot="{data}">
                        <li v-if="data.upload_file_url">
                            <a class="s-link" :href='data.upload_file_url' target="_blank">导入文件</a>
                        </li>
                        <li v-if="data.execute_state == 2 && data.state!=2 && data.error_file_url">
                            <a class="s-link"  target="_blank" style="color: brown" @click="downloadErrorFile(data.error_file_url)">错误报告</a>
                        </li>
                    </template>
                </c-table-column>
                <c-table-column label="备注" name="remark" width="250"></c-table-column>
                <c-table-column label="操作用户" name="create_user_realname" width="120"></c-table-column>
                <c-table-column label="创建时间" name="create_date" width="155"></c-table-column>
                <c-table-column label="完成时间" name="finish_date" width="155"></c-table-column>
            </c-table>
        </c-dialog>
    </div>
</template>

<script>
	import {mapState} from "vuex";

    export default {
        name: 'importLog',
        components: {

        },
        props: {
            workType: [String, Number]
        },

        data() {
            return {
                serachParams:{},
                stateOptions: [
                    {name: '导入成功',value: "2"},
                    {name: '部分成功',value: "1"},
                    {name: '导入失败',value: "0"}
                ],
                executeStateOptions: [
                    {name: '待执行',value: "0"},
                    {name: '执行中',value: "1"},
                    {name: '执行完成',value: "2"}
                ],
            }
        },
        computed: {
            // 获取dictName选项数据
            ...mapState(['userInfo', 'systemConfig']),

            dialogTitle() {
                var workTypeName = {
                    901: '【发货】',
                    902: '【云仓库存】',
                    903: '【会员】',
                    904: '【商品】'
                }[this.workType];
                workTypeName = ''+workTypeName+'数据导入历史记录列表';
                return workTypeName;
            },

            errorFileName() {
                var workTypeName = {
                    901: '【发货】',
                    902: '【云仓库存】',
                    903: '【会员】',
                    904: '【商品】'
                }[this.workType];
                workTypeName = ''+workTypeName+'数据导入错误报告';
                return workTypeName;
            }
        },
        methods: {
              search(data) {
                  data.work_type = this.workType;
                  data = Object.assign(data||{},this.serachParams),
                  this.$refs.table.load({
                      url: '/import/log/list',
                      data
                  });
              },

              open() {
                  this.$refs.search.search();
                  this.$refs.importLogDialog.open();
              },

              //打开上传文件页面
              openExcelImportDialog(){
                  this.$refs.excelImport.open()
              },

              /************下载错误文件************/
              downloadErrorFile(file_url) {
                var suffix = file_url.substring(file_url.lastIndexOf('.')+1).toLowerCase();
                var file_name = this.errorFileName + '.'+suffix;
                this.download({
                    fileName: file_name,
                    url: file_url,
                    loading: {
                        message: '数据文件生成中...'
                    }
                });
              }
        }
	}
</script>
<style lang="stylus" scoped>
.tip-div {
    /* 四个值：上 | 右 | 下 | 左 */
    padding: 20px 20px 20px 20px;
}

.import-steps {
    padding: 10px 20px;
    background-color: #F8F8F8;

    h5 {
        line-height: 36px;
        font-size: 15px;
    }

    p {
        padding: 4px 0;
        line-height: 20px;
        color: #666;
    }
}

.import-explain {
    padding: 20px;

    >>> p {
        padding: 4px 0;
        line-height: 20px;
    }
}

.import-fruit {
    height: 200px;
    background-color: #F8F8F8;

    h1 {
        margin-bottom: 30px;
        font-size: 26px;
    }
}
</style>